function ProductView(element, Page) {
  var self = this;
  this.$element = $(element);
  this.product = {
    type: "product",
    _id: element.getAttribute("data-id"),
    mpn: element.getAttribute("data-mpn"),
    version: element.getAttribute("data-version"),
    versionQty: parseInt(element.getAttribute("data-versions"))
  };
  // lazy loading of the images
  // this.$element.find('.swiper-wrapper .swiper-slide img').each(function () {
  //   if (this.dataset.src) {
  //     this.src = this.dataset.src;
  //   }
  // });
  //init catalog product slider
  // this.swiperThumb = new Swiper(this.$element.find('.swiper-container'), {
  //   slidesPerView: 1,
  //   loop: true,
  //   spaceBetween: 200
  // });
  //
  // this.$element.find('.swiper-button-next').click(function (evt) {
  //   evt.preventDefault();
  //   self.swiperThumb.update();
  //   self.swiperThumb.slideNext(800);
  // });
  //
  // this.$element.find('.swiper-button-prev').click(function (evt) {
  //   evt.preventDefault();
  //   self.swiperThumb.update();
  //   self.swiperThumb.slidePrev(800);
  // });

  this.$element.find('.fav-toggle').click(function (evt) {
    evt.preventDefault();
    if (self.isFav) {
      self.setUnFavState();
      Page.removeProductFromFavs(self.product);
    } else {
      self.setFavState();
      Page.addProductToFav(self.product);
    }
  });

  this.setFavState = function () {
    this.$element.find('.fav-toggle').removeClass("fav").addClass("unfav");
    this.$element.find('.fav-toggle').find('i').removeClass("icon-heart").addClass("icon-heart_filled");
  };

  this.setUnFavState = function () {
    this.$element.find('.fav-toggle').removeClass("unfav").addClass("fav");
    this.$element.find('.fav-toggle').find('i').removeClass("icon-heart_filled").addClass("icon-heart");
  };

  //
  // this.$element.find('.fav').on("click", function (evt) {
  //   evt.preventDefault();
  //
  // });
  //
  // this.$element.find('.unfav').on("click", function (evt) {
  //   evt.preventDefault();
  //   Page.removeProductFromFavs(self.product);
  // });

  this.$element.find('.cart').on("click", function (evt) {
    evt.preventDefault();
    Page.addProductToCart(self.product);
  });

  this.setFav = function (favState) {
    this.isFav = favState;
    if (favState) {
      this.setFavState();
    } else {
      this.setUnFavState();
    }
  };
}